import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ProcessService } from 'src/app/services/process.service';
import { ReportService } from 'src/app/services/report.service';
import { SharedService } from 'src/app/services/sharedService';
import { JsonGenerator } from 'src/app/util/jsonGenerator';
import { Block } from './block';
import { Column } from './column';
import { Row } from './row';
import { PropertyTaxService } from 'src/app/services/propertyTax.service';
@Component({
  selector: 'app-form-creator',
  templateUrl: './form-creator.component.html',
  styleUrls: ['./form-creator.component.css'],
  providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }],
})
export class FormCreatorComponent implements OnInit, OnDestroy {
  @Output() onSingleFormEmit = new EventEmitter<any>()
  @Input() formEditorConfiguration = 'default'
  @Input() form
  @Input() title
  subscriptionAvisBlock: any;
  subscriptionAddRow: any;
  subscriptionUpdateRow: any;
  subscriptionMoveRow: any;
  subscriptionDeleteRow: any;
  subscriptionDeleteBlock: any;
  subscriptionRenameBlock: any;
  subscriptionAddColumn: any;
  subscriptionDeleteColumn: any;
  subscriptionUpdateColumn: any;
  subscriptionSetBlockCondition: any;
  subscriptionUpdateColumnType: any;
  subscriptionUpdateSumTotals: any;
  formCreation = true;
  output: string
  @Input() key = 'page-1-key'
  name = 'New Form'
  type = 'page'
  blockKey: string
  blockName: string
  excelMapping: string
  currentBlockIndex: number;
  blocks: Block[]
  blockStates = [];
  rowSelectItems = [];
  rowCondition;
  rowKey: string
  rowName: string
  rowType: string
  rowMapping: string
  rowDefaultValue: any;
  rowStyle: string
  rowFormula: string
  rowDefault = true
  rowHasAttachment = false
  rowRequired = false
  rowGlobal = false
  rowBold = false;
  rowAvis = false;
  configDropdown = null;
  currentRowIndex: number;
  rows: Row[]
  rowStates = [];
  hasAttachment = false
  columns: Column[]
  columnKey: string
  columnType = "string"
  columnName: string
  currentColumnIndex: number;
  columnStates = [];
  columnBold = false;
  staticTexts = {};
  bolds = {}
  formulas = {};
  checkFormulas = {};
  checkRequired = {};
  boldStaticText = {}
  customValueEmitter = {};
  styles = ["input", "group", "text"]
  rowTypes = ["string", "number", "date", "checkbox", "dropdown", "multiselect", "option",
    "sector dropdown", "branch dropdown", "activity dropdown", "activity detail dropdown",
    "region dropdown", "department dropdown", "city dropdown", "municipality dropdown", "district dropdown", "locality dropdown"]
  columnTypes = ["string", "number", "date", "static text", "checkbox", "option"]
  blockPageTypes = ["page"]

  columnsInRows: boolean[]
  showFormulaSection = false;

  existingColunmKeyError = false;
  existingRowKeyError = false;
  missingRowKeyError = false;

  lastColumn = ""
  jsonObj: any
  jsonObjAPI: any

  reportId: any;
  stageId: any;
  onlyView: any;
  year: any;
  jsonGenerator: JsonGenerator;
  repdbId: any
  fromProcess = false;
  propertyFormTemplate: any = null;
  lotFormTemplate: any = null;
  propertyTemplateLoaded = false;
  lotTemplateLoaded = false;
  stageLoaded = false;

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  constructor(private propertyTaxService: PropertyTaxService, private sharedService: SharedService, private processService: ProcessService,
    private _location: Location,
    private reportService: ReportService, private route: ActivatedRoute, private toastr: ToastrService) {
    this.onlyView = this.route.snapshot.queryParamMap.get("onlyView")
    if (this.onlyView) {
      this.formCreation = false;
    }
    this.route.paramMap.pipe(switchMap((params: ParamMap) => {
      this.reportId = params.get('reportId')
      this.stageId = params.get('stageId')
      this.year = params.get('year')
      this.route
        .queryParams
        .subscribe(paramsq => {
          if (paramsq) {
            this.repdbId = paramsq['id']
          }
        });
      return this.reportService.getReportPage(this.reportId, this.stageId)
    }))
      .subscribe(stagePage => {
        if (!this.isEmpty(stagePage)) {
          this.fromProcess = true;
          this.jsonObj = JSON.parse(JSON.stringify(stagePage))
          this.key = this.jsonObj.key
          this.excelMapping = this.jsonObj.excelMapping
          this.name = this.jsonObj.name
          this.type = this.jsonObj.type

          this.blocks = this.jsonObj.blocks
          this.stageLoaded = true;
          this.trySyncPropertyLotBlocks();
          this.jsonObjAPI = this.jsonGenerator.generateAPI(this.jsonObj)
          this.printOutput()
        }
      });
    this.jsonGenerator = new JsonGenerator();
  }

  selectionChange(event) {
    // if (event.value === 'formula') {
    //   this.showFormulaSection = true
    // }
    // else { this.showFormulaSection = false }
  }
  updateColumnType(val) {
    this.blocks[val.blockIndex]['colType'] = val.columnType;
    this.printOutput()
  }
  updateSumTotals(val) {
    this.blocks[val.blockIndex]['sumTotals'] = val.sumTotals;
    this.printOutput()
  }
  ccData: any
  ngOnInit() {
    this.blocks = []
    this.rows = []
    this.columns = []
    this.blockStates = []
    this.columnsInRows = []
    if (this.formEditorConfiguration === 'singleForm') {
      this.jsonObj = this.form.id ? this.form : {
        key:this.key,
        name: this.title,
        blocks: []
      }

      this.blocks = this.jsonObj.blocks
      this.ccData = {
        key: this.key,
        name: this.title,
        stages: [this.jsonObj]
      }
      this.reportId = this.key
 
       !this.form.id && this.addBlock(this.title)
    }
    this.subscriptionUpdateColumnType = this.sharedService.updateColTypeEmitter.subscribe(
      (val) => {
        this.updateColumnType(val);
      }
    );

    this.subscriptionUpdateSumTotals = this.sharedService.updateSumTotalsEmitter.subscribe(
      (val) => {
        this.updateSumTotals(val);
      }
    );

    this.subscriptionDeleteBlock = this.sharedService.deleteBlock.subscribe(val => {
      this.deleteBlock2(val);
    })
    this.subscriptionRenameBlock = this.sharedService.renameBlock.subscribe(val => {
      this.renameBlock2(val.name, val.ind);
    })
    this.subscriptionSetBlockCondition = this.sharedService.conditionBlock.subscribe(val => {
      this.conditionBlock(val.condition, val.ind);
    })
    this.subscriptionAddRow = this.sharedService.addRow.subscribe(val => {
      this.addRow2(val.blockIndx, val.row);
      if (val.row.type === 'map') {
        let street_row = Object.assign({}, val.row)
        street_row.type = 'street_number'
        street_row.name = '#'
        street_row.key = street_row.key + '_street_number'
        this.addRow2(val.blockIndx, street_row);
        let building_row = Object.assign({}, val.row)
        building_row.type = 'building_id'
        building_row.name = 'Building id'
        building_row.key = street_row.key + '_building_id'
        this.addRow2(val.blockIndx, building_row);
        let location_row = Object.assign({}, val.row)
        location_row.type = 'location'
        location_row.name = 'Location'
        location_row.key = street_row.key + '_location'
        this.addRow2(val.blockIndx, location_row);
        let street_id_row = Object.assign({}, val.row)
        street_id_row.type = 'street_id'
        street_id_row.name = 'Street id'
        street_id_row.key = street_row.key + '_street_id'
        this.addRow2(val.blockIndx, street_id_row);
      }
    })

    this.subscriptionUpdateRow = this.sharedService.updateRow.subscribe(val => {
      this.updateRow2(val.blockIndx, val.row);
    })

    this.subscriptionMoveRow = this.sharedService.moveRow.subscribe(val => {
      this.moveRow(val.blockIndx, val.row, val.direction);
    })

    this.subscriptionDeleteRow = this.sharedService.deleteRowEmitter.subscribe(val => {
      this.deleteRow2(val.blockIndx, val.row);
    })

    this.subscriptionAddColumn = this.sharedService.addColumn.subscribe(val => {
      this.addColumn2(val.blockIndx, val.column);
    })

    this.subscriptionDeleteColumn = this.sharedService.deleteColumnEmitter.subscribe(val => {
      this.deleteColumn2(val.blockIndx, val.column);
    })

    this.subscriptionUpdateColumn = this.sharedService.updateColumnEmmitter.subscribe(val => {
      this.updateColumn2(val.blockIndx, val.column, val.colIndex);
    })
    this.subscriptionAvisBlock = this.sharedService.updateAvisBlockEmitter.subscribe(val => {
      this.avisBlock(val.avis, val.ind);
    })
    this.loadPropertyLotFormTemplates();
  }
  conditionBlock(val, ind) {
    this.blocks[ind].condition = val
  }

  loadPropertyLotFormTemplates() {
    this.propertyTaxService.getForm('propTaxForm').subscribe(res => {
      this.propertyFormTemplate = res;
      this.propertyTemplateLoaded = true;
      this.trySyncPropertyLotBlocks();
    });
  
    this.propertyTaxService.getForm('lotAttrForm').subscribe(res => {
      this.lotFormTemplate = res;
      this.lotTemplateLoaded = true;
      this.trySyncPropertyLotBlocks();
    });
  }

  trySyncPropertyLotBlocks() {
    if (!this.stageLoaded) return;
    if (!this.propertyTemplateLoaded) return;
    if (!this.lotTemplateLoaded) return;
  
    this.syncPropertyLotBlocks();
  }


  ngOnDestroy(): void {
    if (this.subscriptionDeleteBlock) {
      this.subscriptionDeleteBlock.unsubscribe()
    }
    if (this.subscriptionRenameBlock) {
      this.subscriptionRenameBlock.unsubscribe()
    }
    if (this.subscriptionAddRow) {
      this.subscriptionAddRow.unsubscribe()
    }
    if (this.subscriptionUpdateRow) {
      this.subscriptionUpdateRow.unsubscribe()
    }
    if (this.subscriptionMoveRow) {
      this.subscriptionMoveRow.unsubscribe()
    }
    if (this.subscriptionDeleteRow) {
      this.subscriptionDeleteRow.unsubscribe()
    }

    if (this.subscriptionAddColumn) {
      this.subscriptionAddColumn.unsubscribe()
    }

    if (this.subscriptionDeleteColumn) {
      this.subscriptionDeleteColumn.unsubscribe()
    }

    if (this.subscriptionUpdateColumn) {
      this.subscriptionUpdateColumn.unsubscribe()
    }

  }
  avisBlock(val, ind) {
    this.blocks[ind].avisBlock = val
    this.printOutput()
  }
  selectBlock(index) {
    this.currentBlockIndex = index;
    for (var i = 0; i < this.blockStates.length; i++) {
      this.blockStates[i] = false;
    }
    this.blockStates[index] = true;
    this.blockKey = this.blocks[index].key
    this.blockName = this.blocks[index].name
    this.rows = this.blocks[index].rows
    this.columns = this.blocks[index]['columns'] ? this.blocks[index]['columns'] : []
    this.columnsInRows = []
    for (var i = 0; i < this.columns.length; i++) {
      this.columnsInRows[i] = true
    }
  }

  generateBlockName() {
    let x = this.blocks.length + 1;
    while (this.blocks.find(elem => elem.name === "Block " + x) !== undefined) {
      x++;
    }
    return "Block " + x
  }

  generateBlockKey() {
    var x = this.blocks.length + 1;
    while (this.blocks.find(elem => elem.key === x + "") !== undefined) {
      x++;
    }
    return x + ""
  }
  saveFormSingle() {
    this.onSingleFormEmit.emit(this.jsonObj)
  }
  syncPropertyLotBlocks() {
    if (!this.blocks || this.blocks.length === 0) return;
  
    this.blocks = this.blocks.map(block => {
      if (block.sourceForm === 'propTaxForm') {
        return this.getSyncedTemplateBlock(block, this.propertyFormTemplate);
      }
  
      if (block.sourceForm === 'lotAttrForm') {
        return this.getSyncedTemplateBlock(block, this.lotFormTemplate);
      }
  
      return block;
    });
  
    this.printOutput();
  }
  getSyncedTemplateBlock(existingBlock, template) {
    if (!template || !template.blocks || template.blocks.length === 0) {
      return existingBlock;
    }
  
    const templateBlock = JSON.parse(JSON.stringify(template.blocks[0]));
  
    templateBlock.key = existingBlock.key;
    templateBlock.name = existingBlock.name;
    templateBlock.sourceForm = existingBlock.sourceForm;
    templateBlock.sourceBlock = true;
  
    return templateBlock;
  }
  addTemplateBlock(sourceForm) {
    const template =
      sourceForm === 'propTaxForm'
        ? this.propertyFormTemplate
        : this.lotFormTemplate;
  
    if (!template || !template.blocks || template.blocks.length === 0) {
      this.toastr.error('Template form not found');
      return;
    }
  
    const templateBlocks = JSON.parse(JSON.stringify(template.blocks));
  
    templateBlocks.forEach(block => {
      block.key = this.generateBlockKey();
      block.sourceForm = sourceForm;
      block.sourceBlock = true;
  
      if (sourceForm === 'propTaxForm') {
        block.name = block.name || 'Property block';
      }
  
      if (sourceForm === 'lotAttrForm') {
        block.name = block.name || 'Lot block';
      }
  
      this.blocks.push(block);
      this.blockStates.push(false);
    });
  
    this.currentBlockIndex = this.blocks.length - 1;
    this.selectBlock(this.currentBlockIndex);
  
    this.printOutput();
  }

  addBlock(blockType = 'EMPTY', blName = null) {
    if (blockType === 'PROPERTY') {
      this.addTemplateBlock('propTaxForm');
      return;
    }
  
    if (blockType === 'LOT') {
      this.addTemplateBlock('lotAttrForm');
      return;
    }
  
    var b = new Block();
  
    b.key = this.generateBlockKey();
    b.name = blName || ((this.blockName === undefined || this.blockName === '') ? this.generateBlockName() : this.blockName);
  
    this.blocks.push(b);
  
    for (var i = 0; i < this.blockStates.length; i++) {
      this.blockStates[i] = false;
    }
  
    this.blockStates.push(true);
    this.currentBlockIndex = this.blocks.length - 1;
    this.selectBlock(this.currentBlockIndex);
  
    this.rows = [];
    this.columnsInRows = [];
    this.staticTexts = {};
    this.formulas = {};
  
    this.resetRowValues();
  
    setTimeout(() => {
      this.blockName = undefined;
    }, 100);
  
    this.printOutput();
  }

  renameBlock() {
    if (this.blockName !== undefined && this.blockName !== '')
      this.blocks[this.currentBlockIndex].name = this.blockName
    this.printOutput()
  }
  renameBlock2(val, ind) {
    this.blocks[ind].name = val
    this.printOutput()
  }

  deleteBlock(ind) {
    this.blocks.splice(this.currentBlockIndex, 1);
    if (this.currentBlockIndex === this.blocks.length) {
      this.currentBlockIndex -= 1;
    }
    if (this.currentBlockIndex > -1) this.selectBlock(this.currentBlockIndex)
    this.blockName = undefined
    this.printOutput()
  }

  deleteBlock2(ind) {
    this.blocks.splice(ind, 1);
    if (ind === this.blocks.length) {
      ind -= 1;
    }
    if (ind > -1) this.selectBlock(ind)
    this.blockName = undefined
    this.printOutput()
  }

  resetBlockValues() {
    this.blockKey = null
    this.blockName = null
  }

  selectColumn(index) {
    this.currentColumnIndex = index;
    for (var i = 0; i < this.columnStates.length; i++) {
      this.columnStates[i] = false;
    }
    this.columnStates[index] = true;
    this.columnKey = this.columns[index].key
    this.columnName = this.columns[index].name
    this.columnType = this.columns[index].type === 'static_text' ? 'static text' : this.columns[index].type
    this.columnBold = this.columns[index].bold
  }

  generateColumnName() {
    var x = this.columns.length + 1;
    while (this.columns.find(elem => elem.name === "Column " + x) !== undefined) {
      x++;
    }
    return "Column " + x
  }

  generateColumnKey() {
    var x = this.columns.length + 1;
    while (this.columns.find(elem => elem.key === x + "") !== undefined) {
      x++;
    }
    return x + ""
  }

  addColumn() {
    if (this.columns.find(elem => elem.key === this.columnKey) === undefined) {
      var c = new Column();
      c.key = (this.columnKey === undefined || this.columnKey === '') ? this.generateColumnKey() : this.columnKey
      c.name = (this.columnName === undefined || this.columnName === '') ? " " : this.columnName
      c.type = this.columnType === "static text" ? "static_text" : this.columnType
      c.bold = this.columnBold
      this.columns.push(c);
      this.blocks[this.currentBlockIndex]['columns'] = this.columns
      for (var i = 0; i < this.columnStates.length; i++) {
        this.columnStates[i] = false;
      }
      this.columnStates.push(true);
      this.columnsInRows.push(true);
      this.currentColumnIndex = this.columns.length - 1;
      this.selectColumn(this.currentColumnIndex)
      this.resetColumnValues()
      this.resetRowValues()
      this.printOutput()
      this.existingColunmKeyError = false

    } else {
      this.existingColunmKeyError = true
    }
  }

  updateColumn() {
    if (this.columnKey !== undefined && this.columnKey !== '') {
      if (this.columns.find(elem => elem.key === this.columnKey) === undefined
        || this.columns.findIndex(elem => elem.key === this.columnKey) === this.currentColumnIndex
      ) {
        var x = this.columns[this.currentColumnIndex].key
        this.columns[this.currentColumnIndex].name = this.columnName
        this.columns[this.currentColumnIndex].key = this.columnKey
        this.columns[this.currentColumnIndex].type = this.columnType === "static text" ? "static_text" : this.columnType
        this.columns[this.currentColumnIndex].bold = this.columnBold
        for (var i = 0; i < this.rows.length; i++) {
          this.rows[i]['values'].find(elem => elem.column === x).column = this.columnKey
        }
        this.printOutput()
        this.existingColunmKeyError = false
      } else {
        this.existingColunmKeyError = true
      }
    } else {
      console.log("something wicked")
    }
  }
  deleteColumn2(blockIndex, columnKey) {
    this.columns = this.blocks[blockIndex].columns
    this.currentColumnIndex = this.columns.findIndex(elem => elem.key === columnKey)
    this.columns.splice(this.currentColumnIndex, 1);
    if (this.currentColumnIndex === this.columns.length) {
      this.currentColumnIndex -= 1;
    }
    this.rows.forEach(elem => {
      for (var i = 0; i < elem['values'].length; i++) {
        if (elem['values'][i].column === columnKey) {
          elem['values'].splice(i, 1)
          break;
        }
      }
    })
    if (this.currentColumnIndex > -1) this.selectColumn(this.currentColumnIndex)
    this.resetColumnValues()
    this.printOutput()
  }
  deleteColumn() {
    var colKey = this.columns[this.currentColumnIndex].key
    this.columns.splice(this.currentColumnIndex, 1);
    if (this.currentColumnIndex === this.columns.length) {
      this.currentColumnIndex -= 1;
    }
    this.rows.forEach(elem => {
      for (var i = 0; i < elem['values'].length; i++) {
        if (elem['values'][i].column === colKey) {
          elem['values'].splice(i, 1)
          break;
        }
      }
    })
    if (this.currentColumnIndex > -1) this.selectColumn(this.currentColumnIndex)
    this.resetColumnValues()
    this.printOutput()

  }

  resetColumnValues() {
    this.columnKey = undefined
    this.columnName = undefined
    this.columnBold = false;
  }

  selectRow(index) {
    this.currentRowIndex = index;
    for (var i = 0; i < this.rowStates.length; i++) {
      this.rowStates[i] = false;
    }
    this.rowStates[index] = true;
    this.rowKey = this.rows[index].key
    this.rowName = this.rows[index].name
    this.rowType = this.rows[index].type
    this.rowStyle = this.rows[index].style
    this.rowDefault = this.rows[index].default
    this.hasAttachment = this.rows[index].hasAttachment
    this.rowRequired = this.rows[index].required
    this.rowGlobal = this.rows[index].global
    this.rowBold = this.rows[index].bold
    if (this.rows[index]['values'] !== undefined) {
      this.staticTexts = {}
      for (var i = 0; i < this.rows[index]['values'].length; i++) {
        if (this.rows[index]['values'][i].type !== undefined && this.rows[index]['values'][i].type === 'static_text') {
          this.staticTexts[this.rows[index]['values'][i].column] = this.rows[index]['values'][i].value
        }
      }
      this.formulas = {}
      for (var i = 0; i < this.rows[index]['values'].length; i++) {
        this.showFormulaSection = true
        if (this.rows[index]['values'][i].formula !== undefined) {
          this.formulas[this.rows[index]['values'][i].column] = this.rows[index]['values'][i].formula
        }
        if (this.rows[index]['values'][i].required !== undefined) {
          this.checkRequired[this.rows[index]['values'][i].column] = this.rows[index]['values'][i].required
        }
        if (this.rows[index]['values'][i].customValueEmitter !== undefined) {
          this.customValueEmitter[this.rows[index]['values'][i].column] = this.rows[index]['values'][i].customValueEmitter
        }
        if (this.rows[index]['values'][i].bold !== undefined) {
          this.boldStaticText[this.rows[index]['values'][i].column] = this.rows[index]['values'][i].bold
        }
      }
    }
  }

  generateRowName() {
    return "Row " + (this.rows.length + 1)
  }
  generateRowKey() {
    return this.rows.length + 1 + ""
  }

  addRow() {
    if (this.rowKey !== undefined && this.rowKey !== '') {
      if (this.rows.find(elem => elem.key === this.rowKey) === undefined) {
        var r = new Row();
        r.key = this.rowKey
        r.name = this.rowName
        r.style = this.rowStyle
        r.default = this.rowDefault
        r.hasAttachment = this.hasAttachment
        r.required = this.rowRequired
        r.global = this.rowGlobal
        r.bold = this.rowBold
        if (this.columns.length > 0) {
          r['values'] = []
          for (var i = 0; i < this.columns.length; i++) {
            var value = { "column": this.columns[i].key }
            if (this.columnsInRows[i] === true && !['group', 'text'].includes(r.style)) {
              if (this.formulas[this.columns[i].key] === undefined || this.formulas[this.columns[i].key] === '') {
                if (this.rowType !== undefined && this.rowType !== 'formula' && this.rowType !== '')
                  value["type"] = this.rowType
                else
                  value["type"] = this.columns[i].type === "static text" ? "static_text" : this.columns[i].type
              }
              else {
                if (value['type'] !== undefined)
                  delete value['type'];
                value["formula"] = this.formulas[this.columns[i].key]
              }
              if (this.checkRequired[this.columns[i].key] !== undefined) {
                value['required'] = this.checkRequired[this.columns[i].key]
              }
              if (this.customValueEmitter[this.columns[i].key] !== undefined) {
                value['customValueEmitter'] = this.customValueEmitter[this.columns[i].key]
              }
              if (this.boldStaticText[this.columns[i].key] !== undefined) {
                value['bold'] = this.boldStaticText[this.columns[i].key]
              }

            }
            if (this.staticTexts[this.columns[i].key] !== undefined) {
              value['value'] = this.staticTexts[this.columns[i].key]
            }
            r['values'].push(value);
          }
        } else {
          r.type = this.rowType
        }
        this.rows.push(r)
        this.blocks[this.currentBlockIndex].rows = this.rows
        for (var i = 0; i < this.rowStates.length; i++) {
          this.rowStates[i] = false;
        }
        this.rowStates.push(true);
        this.currentRowIndex = this.rows.length - 1;
        this.selectRow(this.currentRowIndex)
        this.resetRowValues()
        this.missingRowKeyError = false;
        this.existingRowKeyError = false;
        this.rowFormula = undefined
        this.showFormulaSection = false;
        this.printOutput()
      }
      else {
        this.existingRowKeyError = true;
      }
    } else {
      this.missingRowKeyError = true;
    }

  }

  updateRow() {
    if (this.rowKey !== undefined && this.rowKey !== '') {
      if (this.rows.find(elem => elem.key === this.rowKey) === undefined
        || this.rows.findIndex(elem => elem.key === this.rowKey) === this.currentRowIndex
      ) {
        this.rows[this.currentRowIndex].name = this.rowName
        this.rows[this.currentRowIndex].key = this.rowKey
        this.rows[this.currentRowIndex].type = this.rowType
        this.rows[this.currentRowIndex].style = this.rowStyle
        this.rows[this.currentRowIndex].default = this.rowDefault
        this.rows[this.currentRowIndex].hasAttachment = this.hasAttachment
        this.rows[this.currentRowIndex].required = this.rowRequired
        this.rows[this.currentRowIndex].global = this.rowGlobal
        this.rows[this.currentRowIndex].bold = this.rowBold

        if (this.rows[this.currentRowIndex]['values'] !== undefined) {
          for (var i = 0; i < this.rows[this.currentRowIndex]['values'].length; i++) {
            if (this.rowType !== undefined && this.rowType !== 'formula' && this.rowType !== '') {
              this.rows[this.currentRowIndex]['values'][i]['type'] = this.rowType
            }
            if (this.staticTexts[this.rows[this.currentRowIndex]['values'][i].column] !== undefined) {
              this.rows[this.currentRowIndex]['values'][i]["value"] = this.staticTexts[this.rows[this.currentRowIndex]['values'][i].column]
            }
            if (this.formulas[this.rows[this.currentRowIndex]['values'][i].column] !== undefined) {
              if (this.rows[this.currentRowIndex]['values'][i]["type"] !== undefined)
                delete this.rows[this.currentRowIndex]['values'][i]["type"];
              this.rows[this.currentRowIndex]['values'][i]["formula"] = this.formulas[this.rows[this.currentRowIndex]['values'][i].column]
            }
            if (this.checkRequired[this.rows[this.currentRowIndex]['values'][i].column] !== undefined) {
              this.rows[this.currentRowIndex]['values'][i]['required'] = this.checkRequired[this.rows[this.currentRowIndex]['values'][i].column]
            }
            if (this.customValueEmitter[this.rows[this.currentRowIndex]['values'][i].column] !== undefined) {
              this.rows[this.currentRowIndex]['values'][i]['customValueEmitter'] = this.customValueEmitter[this.rows[this.currentRowIndex]['values'][i].column]
            }
            if (this.boldStaticText[this.rows[this.currentRowIndex]['values'][i].column] !== undefined) {
              this.rows[this.currentRowIndex]['values'][i]['bold'] = this.boldStaticText[this.rows[this.currentRowIndex]['values'][i].column]
            }
          }

        }

        this.printOutput()
        this.resetRowValues()
        this.existingRowKeyError = false
      } else {
        this.existingRowKeyError = true
      }
    } else {

    }
  }

  deleteRow() {
    this.rows.splice(this.currentRowIndex, 1);
    if (this.currentRowIndex === this.rows.length) {
      this.currentRowIndex -= 1;
    }
    if (this.currentRowIndex > -1) this.selectRow(this.currentRowIndex)
    this.printOutput()
  }


  resetRowValues() {
    this.rowKey = undefined
    this.rowName = undefined
    this.rowType = undefined
    this.rowStyle = undefined
    this.rowDefault = true
    this.hasAttachment = false
    this.rowRequired = false
    this.rowGlobal = false
    this.staticTexts = {}
    this.formulas = {}
    this.checkFormulas = {}
    this.checkRequired = {}
    this.boldStaticText = {}
    this.customValueEmitter = {}
    this.bolds = {}
    this.lastColumn = ""
  }

  selectActiveColumn(index) {
    this.columnsInRows[index] = !this.columnsInRows[index]
  }

  printOutput() {
    this.jsonObj = null
    setTimeout(() => {
      this.output = "{ \"key\":\"" + this.key + "\",\"name\":\"" + this.name + "\",\"type\":\"" + this.type + "\", \"excelMapping\":\"" + this.excelMapping + "\", \"blocks\":" + JSON.stringify(this.blocks) + " }"
      this.jsonObj = JSON.parse(this.output);
      this.jsonObjAPI = this.jsonGenerator.generateAPI(this.jsonObj)
    }, 0);

  }

  calculateBlockClasses(index) {
    return {
      btn: true,
      'selected-component': this.blockStates[index]
    };
  }

  calculateRowClasses(index) {
    return {
      btn: true,
      'selected-component': this.rowStates[index]
    };
  }

  calculateColumnClasses(index) {
    return {
      btn: true,
      'selected-component': this.columnStates[index]
    };
  }

  calculateColumnInRowsClasses(index) {
    return {
      btn: true,
      'selected-component': this.columnsInRows[index]
    };
  }

  addKeyToFormula(event) {
    this.formulas[this.lastColumn] = this.formulas[this.lastColumn] === undefined ? event : this.formulas[this.lastColumn] + " " + event
    this.rowFormula = this.rowFormula === undefined ? event : this.rowFormula + " " + event
  }

  selectLastFormula(col) {
    this.lastColumn = col.key
  }

  formData() {
    return of(
      this.jsonObj
    );
  }
  apiData() {
    return of(
      this.jsonObjAPI
    );
  }

  downloadForm() {
    this.formData().subscribe((res) => {
      this.dyanmicDownloadByHtmlTag({
        fileName: this.key + '.json',
        text: JSON.stringify(res, null, "\t")
      });
    });
  }
  downloadAPI() {
    this.apiData().subscribe((res) => {
      this.dyanmicDownloadByHtmlTag({
        fileName: this.name + '.json',
        text: JSON.stringify(res, null, "\t")
      });
    });
  }

  downloadPDF() {

    var tempStage = {
      "version": 1,
      "key": "test",
      "name": "test",
      "active": true,
      "stages": [
        this.jsonObj
      ]
    }



    this.processService.downloadEditingPDF(tempStage).subscribe
      (data => {
        const blob = data;
        const file = new Blob([blob], {});
        const filename = 'document-' + Date.now() + '.pdf';
        saveAs(file, filename);
      });
  }

  private setting = {
    element: {
      dynamicDownload: null as HTMLElement
    }
  }

  private dyanmicDownloadByHtmlTag(arg: {
    fileName: string,
    text: string
  }) {
    if (!this.setting.element.dynamicDownload) {
      this.setting.element.dynamicDownload = document.createElement('a');
    }
    const element = this.setting.element.dynamicDownload;
    const fileType = arg.fileName.indexOf('.json') > -1 ? 'text/json' : 'text/plain';
    element.setAttribute('href', `data:${fileType};charset=utf-8,${encodeURIComponent(arg.text)}`);
    element.setAttribute('download', arg.fileName);
    var event = new MouseEvent("click");
    element.dispatchEvent(event);
  }
selectedFileName: string = '';
  fileChange(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      this.selectedFileName = file.name;
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        this.fromProcess = false;
        var x = fileReader.result.toString()
        this.jsonObj = JSON.parse(x);
        this.key = this.jsonObj.key
        this.excelMapping = this.jsonObj.excelMapping || null
        this.name = this.jsonObj.name
        this.type = this.jsonObj.type
        this.blocks = this.jsonObj.blocks
        this.jsonObjAPI = this.jsonGenerator.generateAPI(this.jsonObj)
        this.printOutput()
      }
      fileReader.readAsText(file);
    }
  }


  checkOtherBoxes(event) {
    var currentBlock = this.blocks[this.currentBlockIndex]
    if (currentBlock['columns'] !== undefined) {
      for (var c = 0; c < currentBlock['columns'].length; c++) {
        var col = currentBlock['columns'][c]
        if (event.checked) {
          this.checkRequired[col['key']] = true
        } else {
          this.checkRequired[col['key']] = false
        }
      }
    }
  }

  saveInProcess() {
    this.jsonObj = null
    setTimeout(() => {

      this.output = "{ \"key\":\"" + this.key + "\",\"name\":\"" + this.name + "\",\"type\":\"" + this.type + "\", \"excelMapping\":\"" + this.excelMapping + "\", \"blocks\":" + JSON.stringify(this.blocks) + " }"
      this.jsonObj = JSON.parse(this.output);
      this.jsonObjAPI = this.jsonGenerator.generateAPI(this.jsonObj)
      var page = { reportId: this.reportId, stageId: this.stageId, stage: this.jsonObj }


      //if (this.fromProcess){
      this.reportService.updateReportPage(page).subscribe(data => {
        this.reportService.generateExcelMapping(this.repdbId).subscribe(val => {
          this.toastr.success('Success!', `Stage ${this.stageId} successfully updated`, {
            toastClass: "ngx-toastr border-red",
            timeOut: 3000
          });
        })

      })
      // }
      // else{
      //   this.reportService.addReportPage(page).subscribe(data => {
      //     this.reportService.generateExcelMapping(this.repdbId).subscribe(val=>{
      //     this.toastr.success('Success!', `Stage ${this.stageId} successfully added`, {
      //       toastClass: "ngx-toastr border-red",
      //       timeOut: 3000
      //     });
      //   }) });
      // }
    }, 0);
  }

  addRow2(blockIndx, row) {
    if (this.blocks.length > 0) {
      this.selectBlock(blockIndx)
      this.rowMapping = row.mapping
      this.rowKey = row.key;
      this.rowDefaultValue = row.defaultValue;
      this.rowName = row.name;
      this.rowType = row.type;
      this.rowStyle = row.style;
      this.rowHasAttachment = row.hasAttachment;
      this.rowDefault = row.default;
      this.rowRequired = row.required;
      this.rowGlobal = row.global;
      this.rowBold = row.bold;
      this.rowAvis = row.avis;
      this.configDropdown = row.configDropdown;
      this.rows = this.blocks[blockIndx].rows
      if (row.selectItems)
        this.rowSelectItems = row.selectItems
      if (row.condition)
        this.rowCondition = row.condition
      if (this.rowKey !== undefined && this.rowKey !== '') {
        if (this.rows.find(elem => elem.key === this.rowKey) === undefined) {
          var r = new Row();
          r.key = this.rowKey
          r.name = this.rowName
          r.style = this.rowStyle
          r.mapping = this.rowMapping
          r.defaultValue = this.rowDefaultValue
          r.default = this.rowDefault
          r.hasAttachment = this.rowHasAttachment
          r.required = this.rowRequired
          r.global = this.rowGlobal
          r.avis = this.rowAvis
          r.configDropdown = this.configDropdown
          r.bold = this.rowBold
          if (row.selectItems)
            r.selectItems = this.rowSelectItems
          if (row.condition)
            r.condition = this.rowCondition
          if (this.columns.length > 0) {
            r['values'] = []
            for (var i = 0; i < this.columns.length; i++) {
              var value = { "column": this.columns[i].key }
              if (this.columnsInRows[i] === true && !['group', 'text'].includes(r.style)) {
                if (this.formulas[this.columns[i].key] === undefined || this.formulas[this.columns[i].key] === '') {
                  if (this.rowType !== undefined && this.rowType !== 'formula' && this.rowType !== '')
                    value["type"] = this.rowType
                  else
                    value["type"] = this.columns[i].type === "static text" ? "static_text" : this.columns[i].type
                }
                else {
                  if (value['type'] !== undefined)
                    delete value['type'];
                  value["formula"] = this.formulas[this.columns[i].key]
                }
                if (this.checkRequired[this.columns[i].key] !== undefined) {
                  value['required'] = this.checkRequired[this.columns[i].key]
                }
                if (this.customValueEmitter[this.columns[i].key] !== undefined) {
                  value['customValueEmitter'] = this.customValueEmitter[this.columns[i].key]
                }
                if (this.boldStaticText[this.columns[i].key] !== undefined) {
                  value['bold'] = this.boldStaticText[this.columns[i].key]
                }

              }
              if (this.staticTexts[this.columns[i].key] !== undefined) {
                value['value'] = this.staticTexts[this.columns[i].key]
              }
              r['values'].push(value);
            }
          } else {

            if (this.rowType === "") {
              r.type = "string"
            } else {
              r.type = this.rowType
            }
            if (this.rowStyle === "") {
              r.style = "input"
            } else {
              r.style = this.rowStyle
            }
          }
          this.rows.push(r)
          this.blocks[blockIndx].rows = this.rows
          for (var i = 0; i < this.rowStates.length; i++) {
            this.rowStates[i] = false;
          }
          this.rowStates.push(true);
          this.currentRowIndex = this.rows.length - 1;
          this.selectRow(this.currentRowIndex)
          this.resetRowValues()
          this.missingRowKeyError = false;
          this.existingRowKeyError = false;
          this.rowFormula = undefined
          this.showFormulaSection = false;
          this.printOutput()
        }
        else {
          this.existingRowKeyError = true;
        }
      } else {
        this.missingRowKeyError = true;
      }
    }
  }

  updateRow2(blockIndx, row) {
    var index = this.blocks[blockIndx].rows.findIndex(elem => elem.key === row.prevRowKey)
    this.blocks[blockIndx].rows.splice(index, 1, row.row)
    this.printOutput()
    this.resetRowValues()
  }

  deleteRow2(blockIndx, row) {
    if (this.blocks.length > 0) {
      var index = this.blocks[blockIndx].rows.findIndex(elem => elem.key === row)
      this.blocks[blockIndx].rows.splice(index, 1)
      this.printOutput()
      this.resetRowValues()
    }
  }

  updateColumn2(blockIndex, column, colIndex) {
    this.selectBlock(blockIndex)

    if (column.key !== undefined && column.key !== '') {
      if (this.columns.find(elem => elem.key === column.key) === undefined
        || this.columns.findIndex(elem => elem.key === column.key) === colIndex
      ) {
        var x = this.columns[colIndex].key
        this.columns[colIndex].name = column.name
        this.columns[colIndex].key = column.key
        this.columns[colIndex].mapping = column.mapping
        this.columns[colIndex].type = column.type === "static text" ? "static_text" : column.type
        this.columns[colIndex].bold = column.bold
        for (var i = 0; i < this.rows.length; i++) {
          this.rows[i]['values'].find(elem => elem.column === x).column = column.key
        }
        this.printOutput()
        this.existingColunmKeyError = false
      } else {
        this.existingColunmKeyError = true
      }
    } else {
      console.log("something wicked")
    }
  }

  moveRow(blockIndx, row, direction) {
    var index = this.blocks[blockIndx].rows.findIndex(elem => elem.key === row)
    if (direction === 'up' && index > 0) {
      var prevRow = this.blocks[blockIndx].rows[index - 1]
      this.blocks[blockIndx].rows[index - 1] = this.blocks[blockIndx].rows[index]
      this.blocks[blockIndx].rows[index] = prevRow
    }
    if (direction === 'down' && index < this.blocks[blockIndx].rows.length) {
      var nextRow = this.blocks[blockIndx].rows[index + 1]
      this.blocks[blockIndx].rows[index + 1] = this.blocks[blockIndx].rows[index]
      this.blocks[blockIndx].rows[index] = nextRow
    }


    this.printOutput()
    this.resetRowValues()
  }

  updateRowXX(blockIndx, row) {
    this.rowKey = row.row.key;
    this.rowName = row.row.name;
    this.rowType = row.row.type;
    this.rowStyle = row.row.style;
    this.rowDefault = row.row.default;
    this.rowRequired = row.row.required;
    this.rowGlobal = row.row.global;
    this.rowBold = row.row.bold;
    this.rows = this.blocks[blockIndx].rows

    if (this.rowKey !== undefined && this.rowKey !== '') {
      if (this.rows.find(elem => elem.key === this.rowKey) === undefined
        || this.rows.findIndex(elem => elem.key === this.rowKey) === this.currentRowIndex
      ) {
        this.rows[this.currentRowIndex].name = this.rowName
        this.rows[this.currentRowIndex].key = this.rowKey
        this.rows[this.currentRowIndex].type = this.rowType
        this.rows[this.currentRowIndex].style = this.rowStyle
        this.rows[this.currentRowIndex].default = this.rowDefault
        this.rows[this.currentRowIndex].required = this.rowRequired
        this.rows[this.currentRowIndex].global = this.rowGlobal
        this.rows[this.currentRowIndex].bold = this.rowBold

        if (this.rows[this.currentRowIndex]['values'] !== undefined) {
          for (var i = 0; i < this.rows[this.currentRowIndex]['values'].length; i++) {
            if (this.rowType !== undefined && this.rowType !== 'formula' && this.rowType !== '') {
              this.rows[this.currentRowIndex]['values'][i]['type'] = this.rowType
            }
            if (this.staticTexts[this.rows[this.currentRowIndex]['values'][i].column] !== undefined) {
              this.rows[this.currentRowIndex]['values'][i]["value"] = this.staticTexts[this.rows[this.currentRowIndex]['values'][i].column]
            }
            if (this.formulas[this.rows[this.currentRowIndex]['values'][i].column] !== undefined) {
              if (this.rows[this.currentRowIndex]['values'][i]["type"] !== undefined)
                delete this.rows[this.currentRowIndex]['values'][i]["type"];
              this.rows[this.currentRowIndex]['values'][i]["formula"] = this.formulas[this.rows[this.currentRowIndex]['values'][i].column]
            }
            if (this.checkRequired[this.rows[this.currentRowIndex]['values'][i].column] !== undefined) {
              this.rows[this.currentRowIndex]['values'][i]['required'] = this.checkRequired[this.rows[this.currentRowIndex]['values'][i].column]
            }
            if (this.customValueEmitter[this.rows[this.currentRowIndex]['values'][i].column] !== undefined) {
              this.rows[this.currentRowIndex]['values'][i]['customValueEmitter'] = this.customValueEmitter[this.rows[this.currentRowIndex]['values'][i].column]
            }
            if (this.boldStaticText[this.rows[this.currentRowIndex]['values'][i].column] !== undefined) {
              this.rows[this.currentRowIndex]['values'][i]['bold'] = this.boldStaticText[this.rows[this.currentRowIndex]['values'][i].column]
            }
          }

        }

        this.printOutput()
        this.resetRowValues()
        this.existingRowKeyError = false
      } else {
        this.existingRowKeyError = true
      }
    } else {

    }
  }


  setCustomValue(val, col) {
    this.customValueEmitter[col['key']] = val
  }


  addColumn2(blockIndx, column) {
    this.selectBlock(blockIndx)
    this.columns = this.blocks[blockIndx]['columns']
    if (this.columns === undefined) {
      this.columns = []
    }
    if (this.columns.find(elem => elem.key === this.columnKey) === undefined) {
      var c = new Column();
      c.key = (column.key === undefined || column.key === '') ? this.generateColumnKey() : column.key
      c.name = (column.name === undefined || column.name === '') ? " " : column.name
      c.type = column.type === "static text" ? "static_text" : column.type
      c.bold = column.bold
      this.columns.push(c);
      this.blocks[blockIndx]['columns'] = this.columns
      for (var i = 0; i < this.columnStates.length; i++) {
        this.columnStates[i] = false;
      }
      this.columnStates.push(true);
      this.columnsInRows.push(true);
      this.currentColumnIndex = this.columns.length - 1;
      this.selectColumn(this.currentColumnIndex)
      this.resetColumnValues()
      this.resetRowValues()
      this.printOutput()
      this.existingColunmKeyError = false

    } else {
      this.existingColunmKeyError = true
    }
  }

  showCleanForm() {
    this.formCreation = !this.formCreation
  }





}

